import {deleteMethod, get, post, put} from "@iflat/iflat-ui/src/api/methods";

export const INSPECTION_ACTIONS = {
  START: 'start',
  ACCEPT: 'accept',
  REFUSE: 'refuse',
  TOGGLE_SHARE: 'toggleShare',
  SEND_SHARED_LINK: 'sendSharedLink',
  SEND_RESULT_TO_DEVELOPER: 'sendResultToDeveloper'
}
export default {
  async getItem(id, params) {
    const res = await get(`/inspections/${id}`, {params})
    return res.data
  },

  async getItems (params) {
    const res = await get('/inspections', {params})
    return res.data
  },

  async createItem(inspection) {
    const res = await post('/inspections', inspection)
    return res.data
  },

  async updateItem(id, data) {
    const res = await put(`/inspections/${id}`, data)
    return res.data
  },

  async deleteItem(id) {
    return deleteMethod(`/inspections/${id}`)
  },

  async sendAction(id, action, data) {
    const res = await post(`/inspections/${id}/actions`, {action, data})
    return res.data
  }
}
